import { services } from '../../data/site';

/*--------------------
* Service card
----------------------*/
function Service({ service, index }) {
  return (
    <div
      className="reveal glass glass-hover card-sheen group h-full p-6 lg:p-7"
      style={{ transitionDelay: `${index * 0.08}s` }}
    >
      <span className="chip chip-accent font-mono text-[10.5px] uppercase tracking-[.18em]">
        {service.tag}
      </span>

      <h3 className="mt-5 font-display text-[20px] font-[600] leading-[1.25] tracking-[-.015em] text-chalk lg:text-[22px]">
        {service.title}
      </h3>

      <p className="mt-3.5 text-[14.5px] leading-[1.72] text-muted">{service.body}</p>

      <ul className="mt-5 flex flex-wrap gap-2">
        {service.points.map((p) => (
          <li key={p} className="chip text-[12px]">
            {p}
          </li>
        ))}
      </ul>
    </div>
  );
}

/*--------------------
* Service List Section
----------------------*/
export default function ServiceList() {
  return (
    <section id="services" className="section">
      <div className="container">
        <div className="reveal max-w-[720px]">
          <span className="kicker">What I do</span>
          <h2 className="section-title mt-4">
            Hire one engineer,
            <br className="hidden sm:block" /> cover the whole build.
          </h2>
          <p className="lede mt-5">
            From the first architecture decision to the store listing and increasingly,
            the AI layer that makes the product worth opening twice.
          </p>
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:mt-16">
          {services.map((service, i) => (
            <Service key={service.title} service={service} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
